const Rejected = () => {
  return <></>;
};

export default Rejected;
